import styled from '@emotion/styled';
import rem from '../../../../utils/rem/rem';

export const TableRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${rem(16)};
  gap: ${rem(20)};
  padding-top: ${rem(16)};

  svg {
    font-size: 50px;
  }
`;

export const TableWrapper = styled.div`
  width: calc(50vw - 144px);
  flex-grow: 1;
`;

export const StyledReviewChanges = styled.div`
  padding: 0 ${rem(32)};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${rem(16)};
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
`;